import { createAction } from '@reduxjs/toolkit';
import { EmpresaState } from './empresasTypes';
import Empresa from '../../shared/entity/Empresa';

export const setEmpresasAction = createAction<Empresa[]>('EMPRESAS/SET');
export const unsetEmpresasAction = createAction<void>('EMPRESA/UNSET');
